import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';

@JsonObject('model.contact.ContactInfo')
export class ContactInfo extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(String, 'address')
    address?: string;

    @JsonProperty(String, 'city')
    city?: string;

    @JsonProperty(String, 'state')
    state?: string;

    @JsonProperty(String, 'street')
    street?: string;

    @JsonProperty(String, 'zipCode')
    zipCode?: string;

    @JsonProperty(String, 'phone1')
    phone1?: string;

    @JsonProperty(String, 'phone2')
    phone2?: string;

    @JsonProperty(String, 'email')
    email?: string;

    @JsonProperty(String, 'fax')
    fax?: string;

    @JsonProperty(Boolean, 'isDefault')
    isDefault?: boolean;

}